export const DATE_FORMAT_WITH_HOUR = 'HH:mm:ss DD-MM-YYYY';
